import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export const TeamAvatar = ({ member, size = "sm" }) => {
  const dims = size === "sm" ? "h-6 w-6 text-[10px]" : "h-8 w-8 text-xs";
  if (!member) {
    return (
      <span className={`grid ${dims} place-items-center rounded-full bg-slate-200 font-semibold text-slate-500`} title="Unassigned">
        —
      </span>
    );
  }
  const initials = member.name.split(" ").map((n) => n[0]).slice(0, 2).join("");
  return (
    <Avatar className={dims} title={member.name}>
      {member.avatar && <AvatarImage src={member.avatar} alt={member.name} />}
      <AvatarFallback className="bg-slate-800 text-white">{initials}</AvatarFallback>
    </Avatar>
  );
};
